export function VectorSymbol({
  label,
  prime = false,
}: {
  label: string;
  prime?: boolean;
}) {
  const match = /^([a-zA-Z]+)(\d+)$/.exec(label);
  const symbol = match ? (
    <msub>
      <mi>{match[1]}</mi>
      <mn>{match[2]}</mn>
    </msub>
  ) : (
    <mi>{label}</mi>
  );
  return prime ? (
    <msup>
      {symbol}
      <mo>′</mo>
    </msup>
  ) : (
    symbol
  );
}
